<template>
    <v-tooltip bottom>
        <template #activator="{ on }">
            <v-btn :text="text" v-on="on">
                <v-icon left>mdi-network-strength-4-alert</v-icon>
                {{ $t('offline-button.no-connection') }}
            </v-btn>
        </template>
        <span
            >{{ $t('offline-button.internet-connection-not-active') }}</span
        >
    </v-tooltip>
</template>

<script>
export default {
    props: ['text']
};
</script>
